export const SUCCESS = 'SUCCESS'
export const ERROR = 'ERROR'
export const INFO = 'INFO'
